// extracted by mini-css-extract-plugin
export default {"manageBookingTabs":"Booking-ManageBooking-___stylesManageBooking__manageBookingTabs___1uB5n"};